import { render, staticRenderFns } from "./SmartphoneModel.vue?vue&type=template&id=40e67575&"
import script from "./SmartphoneModel.vue?vue&type=script&lang=js&"
export * from "./SmartphoneModel.vue?vue&type=script&lang=js&"
import style0 from "./SmartphoneModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports